import _ from 'lodash';

import { TaskAssignmentTypeLabel } from 'constants/tasks';
import { getDefaultErrorMessage } from 'utils/axios';

import { AssignmentLabel } from './Tasks.constants';

export const prepareTaskRow = task => ({
  ...task,
  id: task.taskId,
  taskTypeLabel: TaskAssignmentTypeLabel[task.taskType?.taskAssignmentType] ?? '',
  assignmentLabel: task.availableForAssignees ? AssignmentLabel.ASSIGNED : AssignmentLabel.PENDING,
});

export const getSelectOptions = (rows, key, selectedValues = []) =>
  _(rows)
    .map(key)
    .concat(selectedValues)
    .filter(Boolean)
    .uniq()
    .sort()
    .map(value => ({ value, label: value }))
    .value();

// HZ-3758: the assign dialog stayed silent on a rejected create — the toast is easy to miss while
// the eye is on the form, so the same server text is kept in the dialog until the next attempt.
export const getSubmitErrorText = error => {
  const message = getDefaultErrorMessage(error);

  return Array.isArray(message) ? message.join(' ') : message;
};
